import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { OwlLoader } from "@/components/OwlLoader";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// This component runs when the OAuth provider redirects back with `#session_id=...`.
// It exchanges the one-time session_id for a Tharwy JWT (server-side), stores it,
// and lands the user on the dashboard.
export default function AuthCallback() {
  const { setUser } = useApp();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/oauth/emergent", { session_id: sessionId });
        // Session is now carried by the httpOnly cookie set on this response.
        setUser(data.user);
        // Clear the sensitive session_id from the URL before landing on the app.
        window.history.replaceState(null, "", "/");
        toast.success("Signed in with Google");
        navigate("/", { replace: true });
      } catch (err) {
        toast.error("Google sign-in failed", {
          description: err?.response?.data?.detail || "Please try again or use email login.",
        });
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-muted-foreground" data-testid="auth-callback">
      <OwlLoader size="lg" />
      <p className="text-sm">Completing secure sign-in…</p>
    </div>
  );
}
